import { initStore } from '../../../common';
import { actions } from './actions';

export const activityLogStore = (): void => {
	const initialState = {
		slice: 'ACTIVITY_LOG',
		logs: [],
		pagesTotal: 1,
		logsLoading: false,
		currentPage: 1,
		rows: [],
		columns: ['Date', 'Time', 'Action'],
		users: [],
		partners: [],
		perPage: '10',
		activePartners: [],
		filtering: false,
		filters: [],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
